import { useState } from "react";
import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay";
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import useApi from "../../hooks/useApi";
const ModalNewClinica = () => {
    const api = useApi();


    const { closeModal } = useModal();

    const [formValues, setFormValues] = useState({
        clinica: ""
    })

    const handleChange = (field) => (event) => {

        let { value } = event.target;

        setFormValues((prev) => ({

            ...prev,
            [field]: value.toUpperCase()

        }))

    }

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const formData = new FormData();

            formData.append('clinica', formValues.clinica)

            const { data } = await api.post('/Painel/API/ASO/SaveNewClinica/', formData, { withCredentials: true })
            console.log(data)

        } catch (e) {

            console.error(e)

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header={true} close={closeModal} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="NOME CLÍNICA"
                            type="text"
                            required
                            valor={formValues.clinica}
                            changeFunc={handleChange('clinica')}
                        />
                        <FormComp
                            valor="SALVAR"
                            type="submit"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )

}

export default ModalNewClinica;